import template from './contact-preview.tpl.html';
import customPrefEmailTemplate from './customs/pref_email.tpl.html';
import contactSingleMessageModalCreator from '../../../modules/messages/helpers/contact-single-message-modal-creator';

class ContactPreviewCtrl {
    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;
        this.alert = this.injector('Alert');
        this.api = this.injector('$http');
        this.state = this.injector('$state');
        this.modal = this.injector('$uibModal');
        this.locale = this.injector('locale');
        this.acl = this.injector('Acl');
        this.params = _.cloneDeep($stateParams);
        this.specialViews = {
            'preferred-email': customPrefEmailTemplate
        };
        this.specialView = null;

        const settingSpecialView = _.get($rootScope.user, 'company.data.settings.companies.special_views.contact-preview');
        if (settingSpecialView
            && Object.keys(this.specialViews).indexOf(settingSpecialView) !== -1) {
            this.specialView = this.specialViews[settingSpecialView];
        }
    }

    sendEmail() {
        contactSingleMessageModalCreator(this.injector, this.contact);
    }

    $onInit() {
        this.delete = _.includes(this.store.getters.slug, 'picklist') ? this.confirmNRemove : this.confirmNDelete;
    }

    show() {
        return this.state.go('app.contacts.details.overview', {
            id: this.contact.id,
            contact: this.contact,
            store: this.store,
            back: this.state.current.name,
            backParams: this.params
        });
    }

    edit() {
        return this.state.go('app.contacts.edit', {
            id: this.contact.id,
            contact: this.contact,
            skipReload: true,
            store: this.store,
            back: this.state.current.name,
            backParams: this.params
        });
    }

    confirmNRemove() {
        // @todo new alert - don't, not used
        this.alert.confirm({
            title: 'Confirm Removal From Picklist',
            message: `Please confirm you want to remove ${this.contact.full_name || this.contact.first_name + ' ' + this.contact.last_name} from this picklist?`,
            type: 'warning',
            confirmBtn: 'Remove',
            wait: true,
        })
            .then(() => {
                this.api.delete('picklists/contacts', {
                    data: {
                        picklists: {
                            count: 1,
                            filters: [
                                {
                                    field: 'id',
                                    operator: 'IN',
                                    value: [this.params.pid]
                                }
                            ]
                        },
                        contacts: {
                            count: 1,
                            filters: [
                                {
                                    field: 'id',
                                    operator: 'IN',
                                    value: [this.contact.id]
                                }
                            ]
                        },
                    }
                })
                    .then(() => {
                        if (this.store) {
                            this.store.dispatch('getData');
                        }
                        this.alert.hide();
                        return this.alert.success(`Successfully moved ${this.contact.full_name} to trash`);
                    }, err => this.alert.handle(err));
            }, err => this.alert.handle(err));
    }

    confirmNDelete() {
        // @todo new alert don't, because it is not used
        this.alert.confirm({
            title: 'Confirm Deletion',
            message: `Please confirm you want to move ${this.contact.full_name || this.contact.first_name + ' ' + this.contact.last_name} to trash?`,
            type: 'warning',
            confirmBtn: 'Delete',
            wait: true,
        })
            .then(() => {
                this.api.delete(`contacts/${this.contact.id}`)
                    .then(() => {
                        if (this.store) {
                            this.store.dispatch('getData');
                        }
                        this.alert.hide();
                        return this.alert.success(`Successfully moved ${this.contact.full_name} to trash`);
                    }, err => this.alert.handle(err));
            }, err => this.alert.handle(err));
    }

}

ContactPreviewCtrl.$inject = [
    '$scope',
    '$injector'
];

angular
    .module('festzelt-os.components')
    .component('contactPreview', {
        bindings: {
            contact: '<',
            store: '<',
            hideActions: '<'
        },
        controller: ContactPreviewCtrl,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/components/components/contact-preview/contact-preview.js